var exports = {
  "IdeList": "IdeList__oxWC12",
  "IdeList--big": "IdeList--big__cZ2sNi",
  "IdeList--small": "IdeList--small__DkFDuA",
  "IdeList--medium": "IdeList--medium__1k3mxR",
};

__webpack_require__.r(module.exports = exports);
